/**
 * Additional charge details
 */
export class ChargeMetadata {
}
